import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.ADD_DEDUCTION_FETCH_VISION_TYPE_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
